module.exports = __webpack_public_path__ + "img/image4-1.e264e852.png";